import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { buildCrawlSearchParams } from '../crawlListParams';

export function useCrawlListSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlSearchValue = searchParams.get('search') ?? '';
  const [crawlSearchInput, setCrawlSearchInput] = useState(urlSearchValue);
  const [previousUrlSearchValue, setPreviousUrlSearchValue] =
    useState(urlSearchValue);

  if (urlSearchValue !== previousUrlSearchValue) {
    setPreviousUrlSearchValue(urlSearchValue);
    setCrawlSearchInput(urlSearchValue);
  }

  const replaceParams = useCallback(
    (searchInput: string) => {
      setSearchParams(buildCrawlSearchParams({ searchInput }), {
        replace: true,
      });
    },
    [setSearchParams],
  );

  const handleCrawlSearchChange = useCallback(
    (value: string) => {
      setCrawlSearchInput(value);
      replaceParams(value);
    },
    [replaceParams],
  );

  const normalizedCrawlSearch = crawlSearchInput.trim().toLowerCase();

  return {
    crawlSearchInput,
    handleCrawlSearchChange,
    normalizedCrawlSearch,
    hasActiveCrawlSearch: normalizedCrawlSearch !== '',
  };
}
